class CollectionBreadcrumb extends HTMLElement {
  constructor() {
    super();
    this.updateBreadcrumbs();
  }

  updateBreadcrumbs() {
    const prevUrl = this.getPrevUrl();
    const isCollection = this.checkUrl(prevUrl);

    if(prevUrl && isCollection ) {
      this.addLink(prevUrl);
    } else {
      this.style.display = 'none';
    }
  }

  getPrevUrl() {
    return document.referrer;
  }

  checkUrl(url) {
    return url.includes('/collections/');
  }

  formatUrl(url) {
    const splitUrl = url.split('/');
    const formatUrlString = splitUrl.pop();
    return formatUrlString.replaceAll('-', ' ');
  }

  addLink(url) {
    const breadcrumb = this.querySelector('a');
    breadcrumb.href = url;
    breadcrumb.innerHTML = this.formatUrl(url).split('?')[0];
  }

}

customElements.define('collection-breadcrumb', CollectionBreadcrumb);